/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Logo_AltInputs */

const en_nav_logo_alt = /** @type {(inputs: Nav_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iter Global Advisory`)
};

const pt_nav_logo_alt = /** @type {(inputs: Nav_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iter Global Advisory`)
};

const es_nav_logo_alt = /** @type {(inputs: Nav_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iter Global Advisory`)
};

/**
* | output |
* | --- |
* | "Iter Global Advisory" |
*
* @param {Nav_Logo_AltInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_logo_alt = /** @type {((inputs?: Nav_Logo_AltInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Logo_AltInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_nav_logo_alt(inputs)
	if (locale === "es") return es_nav_logo_alt(inputs)
	return en_nav_logo_alt(inputs)
});